/* import __COLOCATED_TEMPLATE__ from './filter-collection.hbs.js'; */
var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { get, computed } from '@ember/object';
import Component from '@ember/component';
import { A } from '@ember/array';
import { isBlank, isEmpty } from '@ember/utils';
import { assert } from '@ember/debug';
import { escapeRegExp } from '@square/dashboard-utilities/utils/string';

/**
## Overview

Helper component that allows filtering a collection for items that match a string. Yields `filteredCollection`,
a subset of the collection, where each item has one or more `filterProperties` that match `query`. Only one of
`filterProperty` (String) or `filterProperties` (Array) should be specified.

```example
@title Basic Usage

@controller-properties
{
  collection: [
    {
      name: 'T-Shirt'
    },
    {
      name: 'Hat'
    }
  ]
}

@hbs
{{#filter-collection collection=collection
                     query=query
                     filterProperty="name" as |filteredCollection|}}
  <Input @value={{inputValue}} {{on "change" (action (mut query) inputValue)}} />
  {{#each filteredCollection as |item|}}
    <div>{{item.name}}</div>
  {{/each}}
{{/filter-collection}}
```

@param {Array} [collection] - Collection of items to filter
@param {String} [filterProperty] - the property on each item to test against the query (superceded by filterProperties)
@param {Array} [filterProperties] - list of several properties on each item to test against the query (supercedes filterProperty)

**/
let FilterCollection = (_dec = computed('query', 'collection.[]', 'filterProperties.[]'), _class = class FilterCollection extends Component {
  didReceiveAttrs() {
    super.didReceiveAttrs();
    if (this.filterProperty) {
      this.set('filterProperties', [this.filterProperty]);
    }
    assert('filter-collection: must specify filterProperty or non-empty filterProperties', !isEmpty(this.filterProperties));
  }
  get matchingCollection() {
    const query = this.query;
    if (isBlank(query)) {
      return A(this.collection);
    } else {
      const queryRegExp = new RegExp(escapeRegExp(query), 'gi');
      const matchingCollection = this.collection.filter(option => {
        return this.filterProperties.map(property => get(option, property) === undefined ? '' : get(option, property)).some(value => value.match(queryRegExp));
      });
      return A(matchingCollection);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "matchingCollection", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "matchingCollection"), _class.prototype), _class);
export { FilterCollection as default };